import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { AppConfig } from './app.config';
import { AppAuthorization } from './app.authorization';
import { PHBHPFeaturePackageAuthorizationService } from './Authorization/ph-bhp-feature-package-authorization.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { FiltersService } from './services/filters.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    public layoutService: PHBHPLayoutPackageService,
    private router: Router,
    private config: AppConfig,
    private authorizationService: PHBHPFeaturePackageAuthorizationService,
    private appAuthorization: AppAuthorization,
    private filtersService: FiltersService
  ) {
    if (localStorage.getItem('access_token')) {
      if (!this.config.userData) {
        this.authorizationService.getTokenProfileser().subscribe((res: any) => {
          var obj = res;
          obj.user.roleName = JSON.parse(obj.user.roleName);
          this.config.userData = obj.user;
          this.config.institutions = obj.institutions;
          this.config.campaigns = obj.campaigns;
          this.filtersService.loadFilters();
          localStorage.setItem("campaigns", JSON.stringify(obj.campaigns));
          this.config.userSubject.next(res.profile);
        });
      }
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    this.layoutService.setActionDate();
    if (!localStorage.getItem('access_token')) {
      this.router.navigate(['login']);
      return false;
    }

    if (this.config.userData) {
      return this.checkAuthorizationAndRedirect(route);
    } else {
      return this.config.userSubject.asObservable().pipe(
        take(1),
        switchMap(() => {
          if (!this.config.userData) {
            this.router.navigate(['login']);
            return of(false);
          }
          return of(this.checkAuthorizationAndRedirect(route));
        })
      );
    }
  }

  private checkAuthorizationAndRedirect(route: ActivatedRouteSnapshot): boolean {
    const roleId = this.config.userData.roleName.roleId;
    const isAuthorized = this.appAuthorization.isAuthorization(roleId, route.routeConfig.path, this.router);

    if (isAuthorized) {
      // Redirect to managequota if role is GA and user enters observe
      if (route.routeConfig.path === 'newObserve' && !route.firstChild) {
        if (roleId === 3) {
          this.router.navigate(['/observe/managequota']);
        }
      }
      return true;
    }
  }
}
